
import React from "react";


export default function FooterCard1() {
  return (<>
    <footer className="footer-wrapper">

      {/* --- TOP FOOTER CARD --- */}
      <div className="footer-card">

        {/* LEFT SECTION */}
        <div className="footer-col">
          <h2 className="footer-logo">VW Home Automation</h2>
          <p className="footer-text">
            Lorem ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy
            text ever since the 1500s.
          </p>

          <div className="footer-social">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-twitter"></i>
            <i className="fab fa-linkedin-in"></i>
            <i className="fab fa-instagram"></i>
            <i className="fab fa-youtube"></i>
          </div>
        </div>

        {/* CENTER SECTION */}
        <div className="footer-col">
          <h3 className="footer-title">Need Help</h3>

          <p className="footer-info">
            📞 +12 3456789123
          </p>

          <p className="footer-info">
            🕒 Monday–Saturday : 09.00AM – 08.00PM <br/> Sunday Closed
          </p>

          <p className="footer-info">
            ✉️ xyz123@example.com
          </p>
        </div>

        {/* RIGHT MENU */}
        <div className="footer-col">
          <h3 className="footer-title">Menu Links</h3>

          <ul className="footer-menu">
            <li>About</li>
            <li>Services</li>
            <li>Shop</li>
            <li>Blog</li>
            <button className="footer-buy-btn">Buy Now</button>
          </ul>
        </div>

        {/* INSTAGRAM SIMULATION */}
        <div className="footer-col">
         <p>For payment or technical issues:</p>
        
          <div className="insta-box">support@example.com</div>
        </div>

      </div>

      {/* --- NEWSLETTER SECTION --- */}
      <div className="newsletter">
        <h2>Join Newsletter And Get $10 Discount For Your Next Order!</h2>

        <div className="newsletter-input-fc1">
          <input type="email" placeholder="Email Address"style={{background:"rgba(255, 255, 255, 0.05) "}} />
          <button>Subscribe Now →</button>
        </div>
      </div>

    </footer>
    
    <style>{`.footer-wrapper {
  background: radial-gradient(circle at top left, rgba(78, 174, 252, 1), #0c0e11ff , #020d1dff 70%);
  padding-top: 40px;
  color: white;
  font-family: "Inter", sans-serif;
}

/* TOP CARD */
.footer-card {
  width: 90%;
  margin: auto;
  padding: 40px;
  border-radius: 14px;
  background: rgba(16, 15, 15, 0.41);
  backdrop-filter: blur(24px) saturate(0.05) brightness(0.85);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.4);
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.footer-logo {
  font-size: 22px;
  font-weight: 700;
}

.footer-text {
  color: #ccc;
  line-height: 1.6;
  font-size: 14px;
}

.footer-social i {
  font-size: 16px;
  margin-right: 14px;
  cursor: pointer;
  opacity: 0.8;
  transition: 0.2s;
}

.footer-social i:hover {
  opacity: 1;
  transform: translateY(-3px);
}

.footer-title {
  font-size: 18px;
  font-weight: 700;
}

.footer-info {
  color: #ccc;
  font-size: 14px;
}

.footer-menu {
  list-style: none;
  padding: 0;
}

.footer-menu li {
  margin-bottom: 8px;
  cursor: pointer;
  opacity: 0.8;
}

.footer-menu li:hover {
  opacity: 1;
}

.footer-buy-btn {
  margin-top: 10px;
  padding: 8px 14px;
  border: none;
  background: rgba(144, 202, 249,1);
  border-radius: 6px;
  color: white;
  font-weight: 600;
  cursor: pointer;
}

.footer-buy-btn:hover {
  background: rgba(144, 202, 249,1);
}

.insta-box {
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 10px;
  font-size: 14px;
  opacity: 0.7;
}

/* NEWSLETTER */
.newsletter {
  text-align: center;
  padding: 50px 0 70px;
  width: 90%;
  margin: auto;
}

.newsletter h2 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 24px;
}

.newsletter-input-fc1 {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.newsletter-input-fc1 input {
  width: 320px; 
  padding: 14px 18px;
  border-radius: 8px;
  border: none;
  outline: none;
}

.newsletter-input-fc1 button {
  padding: 14px 24px;
  background: rgba(144, 202, 249,1);
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-weight: 600;
}

.newsletter-input-fc1 button:hover {
  
}

/* RESPONSIVE */
@media (max-width: 900px) {
  .footer-card {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .footer-card {
    grid-template-columns: 1fr;
  }

  .newsletter-input-fc1 {
    flex-direction: column;
  }

  .newsletter-input-fc1 input {
    width: 100%;
  }
}
`}</style>
    </>
  );
}
